import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PageHero, Loader } from "../components/ui-bits";
import { Reveal } from "../components/Reveal";
import { MediaImage } from "../components/MediaImage";

const BG = "https://images.unsplash.com/photo-1504711434969-e33886168f5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

// Newsroom aggregates news + press-style posts
export default function Newsroom() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    Promise.all([
      api.get("/news").then((r) => r.data).catch(() => []),
      api.get("/blog").then((r) => r.data).catch(() => []),
    ]).then(([news, blog]) => {
      const merged = [...news.map((n) => ({ ...n, kind: "news" })), ...blog.map((b) => ({ ...b, kind: "news" }))];
      merged.sort((a, b) => (b.date || "").localeCompare(a.date || ""));
      setItems(merged);
    });
  }, []);

  if (items === null) return <Loader label="Loading newsroom" />;

  return (
    <div data-testid="newsroom-page">
      <PageHero
        eyebrow="From SRAM & MRAM"
        title="Newsroom"
        subtitle="Press releases, corporate announcements and coverage of our companies across global media."
        bg={BG}
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((n, i) => (
            <Reveal key={n.id} delay={(i % 3) * 0.06}>
              <Link to={`/newsroom/${n.slug}`} data-testid={`news-card-${n.slug}`} className="card-vertical rounded-2xl overflow-hidden group flex flex-col h-full">
                <div className="h-48 overflow-hidden">
                  <MediaImage src={n.image_url} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <p className="font-mono text-xs text-emerald-400 mb-2">{n.date}</p>
                  <h3 className="font-display font-semibold text-white line-clamp-3 group-hover:text-emerald-400 transition-colors flex-1">{n.title}</h3>
                  <span className="text-emerald-400 text-sm font-mono mt-4">Read more →</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
